import { post } from '@/services/awsAmplify'

export const postReaction = ({ activityId }: { activityId: UUID }) =>
  post({
    path: `/activity-likes`,
    params: {
      activityId,
    },
  })
